module.exports = __webpack_public_path__ + "static/img/prize_2.892c482.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/winterOlympics/dialog/prize_2.png
// module id = NRA1
// module chunks = 33